export default "/template/resource//static/media/img_lianjieshixiao@2x.d809b0fc.png";